var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "gallery__row gallery__row--tabs" }, [
      _c("div", {
        staticClass: "gallery__intro",
        domProps: { innerHTML: _vm._s(_vm.collection.description) }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "gallery__row" }, [
      _c(
        "select",
        {
          staticClass: "gallery__select",
          attrs: { name: "option", id: "option-select" },
          on: { change: _vm.setSelectedGallery }
        },
        _vm._l(_vm.collection.galleries, function(gallery) {
          return _c(
            "option",
            {
              key: gallery.id,
              domProps: {
                value: gallery.id,
                selected: gallery.id == _vm.selectedGalleryId
              }
            },
            [_vm._v(_vm._s(gallery.title))]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gallery__row gallery__row--gallery" },
      _vm._l(_vm.collection.galleries, function(gallery) {
        return _c("gallery-slider", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: gallery.id == _vm.selectedGalleryId,
              expression: "gallery.id == selectedGalleryId"
            }
          ],
          key: gallery.id,
          attrs: { id: gallery.id, images: gallery.galleryImages }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }